export default __webpack_public_path__ + "static/media/mid-b-14.95d5fa71.jpg";